
import './App.css';
import { Routes } from './Components/Routes';

function App() {
  return (
    <div >
      <Routes/>
    </div>
  );
}

export default App;
